import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ITenantService } from '@app/shared/services/itenant.service';

@Component({
  selector: 'hypecast-admin-actions',
  templateUrl: './actions.component.html',
  styleUrl: './actions.component.scss',
  standalone: true,
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionsComponent {
  private readonly tenantService = inject(ITenantService);
  private readonly tenantsWithPrivacyPolicy = ['eon'];

  readonly isCollapsed = input(false);

  showPrivacyPolicyDialog(): boolean {
    return this.tenantsWithPrivacyPolicy.includes(this.tenantService.getTenantName());
  }
}
